import React from "react";
import { Modal, Button, Form, ModalContent, ModalHeader, ModalActions } from "@/components/bp/bp-ui";
import { Formik, Form as FormikForm } from "formik";
import * as Yup from "yup";
import SemanticFormikField from "@app/components/SemanticFormikField";
import SemanticFormikInput from "@common/Forms/SemanticFormikInput";
import { BPButton } from "@/components/bp/bpbutton";

interface CreateRoleDialogProps {
    open: boolean;
    onClose: () => void;
    onCreate: (roleName: string) => Promise<void>;
}

export const CreateRoleDialog: React.FC<CreateRoleDialogProps> = ({ open, onClose, onCreate }) => (

    <Formik
        initialValues={{ name: "" }}
        validationSchema={Yup.object({
            name: Yup.string().required("Role name is required"),
        })}
        onSubmit={async (values, actions) => {
            await onCreate(values.name);
            actions.setSubmitting(false);
            onClose();
        }}
    >
        {({ handleSubmit, isSubmitting }) => (
            <Modal as={FormikForm} open={open} onClose={onClose} className="ui form">
                <ModalHeader>Create New Role</ModalHeader>
                <ModalContent>
                    <SemanticFormikInput
                        name="name"
                        label="Role Name"
                        placeholder="Enter role name"
                        required
                    />
                </ModalContent>
                <ModalActions>
                    <BPButton type="button" onClick={onClose} disabled={isSubmitting}>
                        Cancel
                    </BPButton>
                    <BPButton type="submit" primary loading={isSubmitting}>
                        Create
                    </BPButton>
                </ModalActions>

            </Modal>

        )}
    </Formik>
);